<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.tournament_refund_list")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker(@update="submit")
                //- DateRangePicker(:value="dateRange")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-form-checkbox(
                  ref="working_date"
                  v-model="working_date"
                ) {{ this.$t("message.search_with_working_date") }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="refundList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(working_date)="row")
                    span {{ (row.item.working_date) ? $moment(row.item.working_date).format("YYYY-MM-DD") : $moment(row.item.bet_time).format("YYYY-MM-DD") }}
                    br
                    span #[b {{ row.item.bet_id }}]
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(event)="row")
                    template(v-if="row.item.room_type")
                      span {{ $t("ui.room_" + row.item.room_type) }}
                      br
                    span.mr-1 No.{{ row.item.room_id }}
                    template(v-if="row.item.position")
                      i.fas.fa-trophy.gold-trophy(v-if="row.item.position == 1")
                      i.fas.fa-trophy.silver-trophy(v-if="row.item.position == 2")
                      i.fas.fa-trophy.bronze-trophy(v-if="row.item.position == 3")
                  //- template(v-slot:cell(detail)="row")
                  
                  template(v-slot:cell(bet)="row")
                    span(:class="$helpers.getNumberClass(row.item.bet)") #[b {{ row.item.bet | currency }} ]
                  template(v-slot:cell(result_status)="row")
                    span {{ row.item.result_status }}
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DatePicker from "@/library/DatePicker.vue";

export default {
  components: {
    SubmitButton,
    DateRangePicker,
    DatePicker
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      working_date: true,
      refundList: [],
      filter: null,
      sortBy: "bet_id",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "working_date",
          label: this.$t("ui.date_time"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "25%"
          }
        },
        {
          key: "bet",
          label: this.$t("ui.amount"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "12%"
          }
        },
        {
          key: "result_status",
          label: this.$t("ui.status"),
          sortable: true,
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "12%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let search_by_working_date = (this.working_date) ? 1 : 0
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getTournamentRefundList", { start_date, end_date, search_by_working_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            console.log("response", response)
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.refundList = response.data
                this.totalRows = response.data.length > 0 ? this.refundList[0]["totalrows"] : 0
              } else {
                this.refundList = []
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.refundList = []
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    }
  }
};
</script>

<style lang="scss" scoped>
  .custom-checkbox {
    width: 100% !important;
  }
</style>